<script>
var isArray = Array.isArray ?
    function (obj) {
      return Array.isArray(obj);
    } :
    function (obj) {
      return Object.prototype.toString.call(obj) === '[object Array]';
    };
import { Pie } from 'vue-chartjs';

export default {
  extends: Pie,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  methods:{
    getValueAtIndexOrDefault : (value, index, defaultValue) => {
    if (value === undefined || value === null) {
      return defaultValue;
    }

    if (isArray(value)) {
      return index < value.length ? value[index] : defaultValue;
    }

    return value;
  }
  },
  mounted () {

    if (!this.chartdata || !this.chartdata.labels || !this.chartdata.datasets) {
      console.error("Invalid chartdata provided:", this.chartdata);
      return;
    }
    //console.log(`in chart mounted function`);
    this.options.legend.labels.generateLabels = (chart) => {

          chart.legend.afterFit = function () {
            // var width = this.width; 
            // console.log(this.lineWidths);
           
            this.lineWidths = this.lineWidths && this.lineWidths.map( () => this.width-12 );
            
            this.options.labels.padding = 10;
            this.options.labels.boxWidth = 15;
          };

          var data = chart.data;
          // console.log(data);
          //https://github.com/chartjs/Chart.js/blob/1ef9fbf7a65763c13fa4bdf42bf4c68da852b1db/src/controllers/controller.doughnut.js
          if (data.labels && data.labels.length && data.datasets.length) {
            return data.labels.map((label, i) => {
              var meta = chart.getDatasetMeta(0);
              var ds = data.datasets[0];
              var arc = meta.data[i];
              var custom = arc && arc.custom || {};
              var getValueAtIndexOrDefault = this.getValueAtIndexOrDefault;
              var arcOpts = chart.options.elements.arc;
              var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
              var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
              var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
              
              return {
                text: label,
                fillStyle: fill,
                strokeStyle: stroke,
                lineWidth: bw,
                hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

                // Extra data used for toggling the correct item
                index: i
              };
            });
          }
          return [];
        }
    this.renderChart(this.chartdata, this.options)
  }
}

</script>